import AppLayout from "./AppLayout"

function Home() {
  return (
    <><AppLayout /></>
  )
}

export default Home